import { cn } from "@/lib/utils";

const JobPriorityBadge = ({ priority }) => {
  const getPriorityStyle = (priority = "") => {
    switch (priority?.toLowerCase()) {
      case "high":
        return {
          text: "text-red-400",
          bg: "bg-red-400/10",
          border: "border-red-400/30",
          label: "High",
        };
      case "normal":
        return {
          text: "text-yellow-500",
          bg: "bg-yellow-400/10",
          border: "border-yellow-400/30",
          label: "Normal",
        };
      case "low":
        return {
          text: "text-green-500",
          bg: "bg-green-400/10",
          border: "border-green-400/30",
          label: "Low",
        };
      default:
        return {
          text: "text-gray-500",
          bg: "bg-gray-400/10",
          border: "border-gray-400/30",
          label: "N/A",
        };
    }
  };

  const style = getPriorityStyle(priority);

  return <span className={cn("px-2 py-1 text-xs rounded-full border", style.text, style.bg, style.border)}>{style.label}</span>;
};

export default JobPriorityBadge;
